import { useEffect } from 'react'
import HeadMeta from 'components/common/HeadMeta'
import Template from 'components/cases/listpage/hip/Template'

const Hip: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <HeadMeta
        keyword={
          'DX戦略 組織開発 人材育成 生成AI デジタルトランスフォーメーション'
        }
        image={'https://www.i3design.jp/ogp_logo.png'}
        url={'https://www.i3design.jp/cases/hip'}
        title="組織開発・人材育成 | 事例 | i3DESIGN アイスリーデザイン"
        description="組織開発・人材育成サービスのケーススタディを紹介します｜i3DESIGNはビジネス・デザイン・テクノロジーの力を駆使して、顧客のミッションをあらゆる角度から伴走支援するデジタルイノベーションパートナー事業を展開しています。"
      />
      <Template />
    </>
  )
}

export default Hip
